/**
 * Check if the value is a zero value string like "0px" or "0%"
 */
const isZeroValueString = (v) => /^0[^.\s]+$/u.test(v);

export { isZeroValueString };
//# sourceMappingURL=is-zero-value-string.mjs.map
